import React, { useEffect, useRef, useState } from 'react'
import { Upload, Button, message, Row, Col } from 'antd'
import ModalDrag from '@/component/ModaDrag/ModalDrag'
import GlobalCss from '@/global.module.less'
import styles from './knowcell-upload-modal.module.less'
import Cookies from 'js-cookie'
import * as constants from '@/constants/constants'
import { CheckCircleFilled } from '@ant-design/icons'
import SparkMD5 from 'spark-md5'
import { sendHttpPostRequest } from 'api/http-request'

const { Dragger } = Upload

const KnowCellUploadModal = (props: any) => {
  const {
    actionCallback,
    open,
    setOpen,
    uploadType,
    uploadDataProps,
    apiUrl,
    moduleType, from_oam  } = props

  const SIZE = 1024 * 1024 * 5

  const uploadData = Object.assign(uploadDataProps, {
    sessionid: Cookies.get('sessionid'),
    sid: Cookies.get('sessionid'),
  })

  const [fileList, setFileList] = useState<any>([])
  const [uploadStatus, setUploadStatus] = useState('')
  const [isUploading, setIsUploading] = useState(false)
  const [uploadName, setUploadName] = useState('')
  const [makeSureModalVis, setMakeSureModalVis] = useState(false)
  const [chunksState, setChunksState] = useState<any[]>([])
  const [uploadedPercent, setUploadedPercent] = useState(0)

  const resumeStatus = useRef(0)

  const alreadyUploadChunkIndexList = useRef<any>([])

  const [md5Code, setMd5Code] = useState<any>('')

  const handleCancel = () => {
    if (fileList?.some((f) => f.status == 'uploading')) {
      setMakeSureModalVis(true)
    } else {
      setFileList([])
      setOpen(false)
      reIndex.current = 0
      result.current = []
      setIsUploading(false)
      actionCallback()
    }
  }
  useEffect(() => {
    return () => {
      setFileList([])
    }
  }, [])

  const reIndex = useRef(0)
  let result = useRef<any>([])

  // 并发请求函数
  const concurrencyRequest = (urls, maxNum) => {
    return new Promise((resolve) => {
      if (urls.length === 0) {
        resolve([])
        return
      }
      const results = []
      let index = 0 // 下一个请求的下标
      let count = 0 // 当前请求完成的数量

      // 发送请求
      async function request() {
        if (index === urls.length) return
        const i = index // 保存序号，使result和urls相对应
        const url = urls[index]
        index++
        //console.log(url)
        const api_url = from_oam == true ? 'course/api/oam_upload_video_chunk' : 'course/api/user_upload_video_chunk'
        try {
          const resp = await fetch(
            constants.BACKEND_API_URL + api_url,
            {
              method: 'POST',
              body: url,
            }
          )
            .then((res: any) => res.json())
            .then((data) => {
              setUploadedPercent(
                Math.floor(
                  (data.data.uploaded_count / chunksState.length) * 100
                )
              )
              return data
            })
          results[i] = resp
        } catch (err) {
          results[i] = err
        } finally {
          count++
          // 判断是否所有的请求都已完成
          if (count === urls.length) {
            console.log('完成了')
            resolve(results)
          }
          request()
        }
      }

      // maxNum和urls.length取最小进行调用
      const times = Math.min(maxNum, urls.length)
      for (let i = 0; i < times; i++) {
        request()
      }
    })
  }

  const handleUploadRequest = () => {

    console.log('开始上传')
    setIsUploading(true)
    setUploadStatus('uploading')
    const list: any[] = []
    for (let i = 0; i < chunksState.length; i++) {
      if (
        resumeStatus.current == 2 &&
        alreadyUploadChunkIndexList.current.length > 0 &&
        alreadyUploadChunkIndexList?.current?.includes(i)
      ) {
        continue
      }
      const formData: any = new FormData()
      formData.append('sessionid', Cookies.get('sessionid'))
      formData.append('chunk_num', i)
      formData.append('video_chunk', chunksState[i])
      formData.append('chunk_count', chunksState.length)
      formData.append('knowledgecell_id', uploadData.knowledgecell_id)
      formData.append('video_md5', md5Code)
      list.push(formData)
 
    }
    concurrencyRequest(list, 5).then((results: any[]) => {
      if (
        results.length == list.length &&
        results.every((item) => item.code == 0)
      ) {
        const formData: any = new FormData()
        formData.append('sessionid', Cookies.get('sessionid'))
        formData.append('filename', uploadName)
        formData.append('knowledgecell_id', uploadData.knowledgecell_id)
        formData.append('video_md5', md5Code)

        const api_url = from_oam == true ? 
                        constants.BACKEND_API_URL + 'course/api/oam_merge_video_chunk'
                        :constants.BACKEND_API_URL + 'course/api/user_merge_video_chunk'


        try {
          fetch(
            api_url,
            {
              method: 'POST',
              body: formData,
            }
          )
            .then((res) => res.json())
            .then((data) => {
              if (data.code == 0) {
                message.success(data.msg)
                setUploadStatus('done')
              } else {
                setUploadStatus('error')
              }
            })
        } catch (error) {
          setUploadStatus('error')
          message.error(error + '合并文件出错')
        }
      }
    })
  }

  
  
  const makeChunk = (file, size = SIZE) => {
    const chunks = []
    for (let i = 0; i < file.size; i += size) {
      const chunk = file.slice(i, i + size)
      chunks.push(chunk)
    }
    return chunks
  }

  const getFileMD5 = (file) =>{
  
    const spark = new SparkMD5.ArrayBuffer()
    // 把文件开始传入spark
    const fileReader = new FileReader()
    fileReader.onload = (e:any) => {
      spark.append(e.target.result)
      // spark计算出MD5后的结果
      const _md5 = spark.end()
      setMd5Code(_md5)
      console.log(_md5)
    }

    // fileReader读取二进制文件
    fileReader.readAsArrayBuffer(file)
  }

  const uploadProps: any = {
    name: uploadType,
    multiple: true,
    accept: moduleType == 1 ? '.pdf' : '.mp4,.mov,.MP4,.MOV',
    showUploadList: false,
    customRequest: handleUploadRequest,

    beforeUpload: (file, FileList) => {
          getFileMD5(file)
          let data = {
            video_md5: md5Code,
            knowledgecell_id: uploadData.knowledgecell_id,
            file_name: file.name
          }
          setUploadName(file.name)
    
          setChunksState(makeChunk(file))
    
          setFileList([
            ...FileList.map((f) =>
              Object.assign(f, { status: 'waiting', percent: 0 })
            ),
          ])

          return new Promise((resolve, reject) => {
            sendHttpPostRequest(
              from_oam == true ? 'course/api/oam_resume_upload' : 'course/api/user_resume_upload' ,
              data,
              (res: any) => {
                if (res.code == 0) {
                  setUploadedPercent(
                    Math.floor(
                      (res.data.uploaded_count / makeChunk(file).length) * 100
                    )
                  )
                  if (res.data.uploaded_status == 1) {
                    message.error(res.msg)
                    reject()
                  } else if (res.data.uploaded_status == 2) {
                    resolve(res.data.uploaded_status)
                    resumeStatus.current = res.data.uploaded_status
                    alreadyUploadChunkIndexList.current = res.data.uploaded_chunk
                  } else {
                    resumeStatus.current = res.data.uploaded_status
                    resolve(res.data.uploaded_status)
                  }
                } else {
                  reject()
                }
              }
            )
          })      
    },
    action: constants.BACKEND_API_URL + apiUrl,
    data: uploadData,
  }


  const uploadModalContent = (
    <div className={styles.modalContain}>
      <div
        // style={uploadStatus == 'done' ? { height: '285px' } : {}}
        className={styles.uploadContain}
      >
        <div
          // style={uploadStatus == 'done' ? { height: '285px' } : {}}
          className={styles.progressContain}
          hidden={!isUploading}
        >
          <Row
            align={'middle'}
            justify={'space-between'}
            style={{ height: '40px', borderBottom: '1px solid #eee' }}
          >
            <Col flex={'300px'}>文件名</Col>
            <Col flex={'100px'} style={{ textAlign: 'center' }}>
              状态
            </Col>

          </Row>
          <div className={styles.progress}>
            {fileList
              ?.filter((item) => item.status !== 'deleted')
              .map((f) => (
                <Row
                  key={f.uid}
                  align={'middle'}
                  justify={'space-between'}
                  style={{ height: '40px', width: '592px' }}
                >
                  <Col flex={'350px'} className={GlobalCss.oneLineTextOverflow}>
                    {f.name}
                    {/* {'  '} {uploadPercent != 100 && uploadPercent + '%'} */}
                  </Col>
                  <Col flex={'100px'} className={GlobalCss.ColFlex}>
                    <div
                      className={
                        uploadStatus == 'done'
                          ? styles.uploadComplete
                          : uploadStatus == 'waiting'
                          ? styles.uploadWaiting
                          : uploadStatus == 'uploading'
                          ? styles.uploading
                          : uploadStatus == 'error'
                          ? styles.uploadError
                          : ''
                      }
                    ></div>
                    <span>
                      {uploadStatus == 'uploading' ? (
                        <span>
                          <span
                            style={{ fontSize: '16px', color: '#4285F4' }}
                            className="iconfont icon-zhengzaitingzhi"
                          ></span>{' '}
                          {'上传' + uploadedPercent + '%'}
                        </span>
                      ) : uploadStatus == 'waiting' ? (
                        '等待中'
                      ) : uploadStatus == 'done' ? (
                        '上传成功'
                      ) : (
                        '上传失败'
                      )}
                    </span>
                  </Col>
                </Row>
              ))}
          </div>
        </div>

        <div hidden={isUploading} style={{ height: '380px' }}>
          <Dragger {...uploadProps}>
            <Button style={{boxShadow:'none', textShadow:'none', width:80, height:32}}  className={GlobalCss.pribtn} type="primary">
              上 传
            </Button>
            <h2>将文件拖到此处，或点击上传</h2>
            <span className={styles.tip}>
              {moduleType != 1 ? '请上传.mov或.mp4视频格式文件' : '请上传PDF文件'}
            </span>
          </Dragger>
        </div>
      </div>
    </div>
  )

  return (
    <div>
      {/* <Button onClick={showModal}>上传文件</Button> */}
      <ModalDrag
        width={720}
        style={{ minHeight: '500px' }}
        bodyStyle={{ minHeight: '400px' }}
        open={open}
        footer={null}
        modalTitle={
          <Row align={'middle'} style={{ gap: '5px' }}>
            <Col className={GlobalCss.modalTitle}>
              <span>上传知识点讲义</span>
            </Col>
            <Col>
              {fileList.length > 0 ? (
                fileList?.every((f) => f.status == 'done') ? (
                  <CheckCircleFilled
                    style={{ fontSize: '15px', color: '#4BB04F' }}
                  />
                ) : (
                  <span
                    style={
                      fileList?.some((f) => f.status == 'uploading')
                        ? {
                            fontSize: '15px',
                            color: '#4285F4',
                          }
                        : {
                            fontSize: '15px',
                            color: '#F24957',
                          }
                    }
                    className={
                      'iconfont ' +
                      (fileList?.some((f) => f.status == 'uploading')
                        ? 'icon-zhengzaitingzhi'
                        : fileList?.some((f) => f.status == 'error')
                        ? 'icon-tingzhi'
                        : '')
                    }
                  ></span>
                )
              ) : (
                ''
              )}
            </Col>
          </Row>
        }
        maskClosable={false}
        destroyOnClose={true}
        // onOk={handleOk}
        onCancel={handleCancel}
        modalContent={uploadModalContent}
      />
      <ModalDrag
        width={460}
        modalContent={
          <div
            style={{
              margin: '0 auto',
              textAlign: 'center',
              lineHeight: '100px',
            }}
          >
            关闭弹窗后正在运行的任务将会终止，确认关闭？
          </div>
        }
        open={makeSureModalVis}
        centered
        bodyStyle={{ minHeight: '100px' }}
        onCancel={() => setMakeSureModalVis(false)}
        onOk={() => {
          setMakeSureModalVis(false)
          setFileList([])
          setOpen(false)
          reIndex.current = 0
          result.current = []
          setIsUploading(false)
          actionCallback()
          message.success('已停止上传')
          // document.getElementById('deleteModalBtn')?.click()
        }}
        modalTitle={<span className={GlobalCss.modalTitle}>提示</span>}
      />
    </div>
  )
}

export default KnowCellUploadModal
